import * as React from 'react';
import { useTrackedPointer } from '../utils/useTrackedPointer';

export function useSuggestMouseEvents(setSelectedItemIndex: (value: number | undefined) => void) {
  const { wasPointerMoved, pointerUpdate } = useTrackedPointer();
  const onMouseMove = React.useCallback(
    (index: number): React.MouseEventHandler =>
      e => {
        if (wasPointerMoved(e)) {
          setSelectedItemIndex(index);
        }
      },
    [setSelectedItemIndex, wasPointerMoved],
  );
  const onMouseLeave: React.MouseEventHandler = React.useCallback(
    e => {
      if (wasPointerMoved(e)) {
        setSelectedItemIndex(undefined);
      }
    },
    [setSelectedItemIndex, wasPointerMoved],
  );
  const onMouseEnter: React.MouseEventHandler = React.useCallback(
    e => {
      pointerUpdate(e);
    },
    [pointerUpdate],
  );

  return { onMouseMove, onMouseEnter, onMouseLeave };
}
